import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";

import axios from "axios/index";
import {Button, Hidden, Grid} from '@material-ui/core';

import urls from "../../../../utils/urls";
import {tokenHeader} from "../../../../utils/headers";
import {ajaxHandler} from "../../../../utils/errors";
import {dateTimeFormat} from "../../../../utils/formatters";
import Modal from "../../../../components/modal";

import pin from "./../../../../assets/pin.png";
import checkin_image from "./../../../../assets/checkin.png";
import done from "./../../../../assets/done.png";
import './styles.scss';
import {checkInStation} from "../../../../actions/visits_actions";

class CheckIn extends Component {

    constructor(props){
        super(props);
        this.state={
            showModal:false,
            modalInfo: {},
            userLocation: false,

            xhr: false
        }
    }

    componentDidMount(){
        this._getLocation(()=>{});
    }

    _getLocation = (callbackError) => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                position => {
                    this.setState({
                        userLocation: {
                            lat: position.coords.latitude.toFixed(5),
                            lng: position.coords.longitude.toFixed(5)
                        },
                        showModal: false
                    });
                },
                callbackError
                ,{
                    enableHighAccuracy: true
                }
            );
        }else{
            callbackError();
        }
    };

    checkInVisit = () =>{
        if(!this.props.stations.selectedStation || this.props.stations.selectedStation === 0){
            return false;
        }

        let data ={
            station: this.props.stations.selectedStation,
            tm_user: this.props.user.id,
            latitude: this.state.userLocation.lat,
            longitude: this.state.userLocation.lng
        };

        this.setState({xhr: true});

        const check_in_url = `${urls.API_ROOT}/api/v1/station-check-ins/`;
        axios
            .post(check_in_url,data, tokenHeader())
            .then(() => {
                this.setState({xhr: false});
                this.closeModal();
                this.props.checkInStation(true)}
            )
            .catch(e => {
                this.setState({xhr: false});
                ajaxHandler(e);
            });
    };

    showModal = () =>{

        let modalInfo = {
            accept: this.checkInVisit,
            cancel: this.closeModal,
            text: "¿Se encuentra de visita en esta estación?",
            subtext: '',
            acceptText: 'Aceptar'
        };

        if(!this.state.userLocation){
            modalInfo = {
                accept: () => this._getLocation(this._locationError),
                cancel: this.closeModal,
                text: "No se pudo obtener su ubicación",
                subtext: "Para hacer el Check-In es necesario que le des permiso a la web a acceder a tu ubicación",
                acceptText: 'Reintentar'
            };
        }

        this.setState({showModal:true, modalInfo});
    };

    closeModal = () =>{
        this.setState({showModal:false});
    };

    render() {
        let {visits, stations} = this.props;
        let {didCheckedIn} = visits;
        let {selectedStation} = stations;
        let {modalInfo, showModal, xhr} = this.state;
        let checkInDisabled = (didCheckedIn || selectedStation === 0);

        return (
            <div className={'check-in-container'}>
                <Grid container>
                    <Grid item xs={6}>
                        <img src={pin} className={"icon"} alt={'Pin'} />
                        <Hidden xsDown>
                            <div className={"site-visit"}>SITE VISIT</div>
                        </Hidden>
                        <Hidden smUp>
                            {visits && visits.lastVisitInfo ?
                                <div className={"user-checkin"}>
                                    <div className={"username"}>{visits.lastVisitInfo.tm_user_display}</div>
                                    <div className={"date"}>{dateTimeFormat(visits.lastVisitInfo.created_at)}</div>
                                </div>
                                : <div />
                            }
                        </Hidden>
                    </Grid>
                    <Grid item xs={6}>
                        <Button onClick={this.showModal} disabled={checkInDisabled}
                                className={`checkin ${(!didCheckedIn && selectedStation > 0) ? '' : 'grey-checkin'}`}>
                            <div className={"btn-text"}>Check-in</div>
                            <img src={didCheckedIn ? done : checkin_image} className={"icon-check"} alt={"Check-in"}/>
                        </Button>
                    </Grid>
                </Grid>
                {showModal &&
                <Modal
                    open={showModal}
                    text={modalInfo.text}
                    subtext={modalInfo.subtext}
                    cancel={modalInfo.cancel}
                    accept={modalInfo.accept}
                    acceptText={modalInfo.acceptText}
                    loading={xhr}
                />
                }

            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        user: state.user,
        visits: state.visits,
        stations: state.stations
    }
};


const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({checkInStation}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckIn);


// WEBPACK FOOTER //
// ./src/containers/site-visits/components/checkIn/CheckIn.js